<script setup lang="ts">
import { cn } from 'cn'

import type { BadgeProps } from './types'

import { badgeVariants } from './variants'

const props = withDefaults(defineProps<BadgeProps>(), {
  color: 'neutral',
  variant: 'solid',
  size: 'md',
  aspect: 'default',
})
</script>

<template>
  <div :class="cn(badgeVariants({ color, variant, size, aspect }), props.class)">
    <slot />
  </div>
</template>
